module.exports = __webpack_public_path__ + "img/giropay.00ce6245.svg";